import { bindActionCreators } from "redux"
import TemplateView from "../../TemplateView"
import {connect} from "../../redux/utils"
import ClassicBridge from "../../next/ClassicBridge"
import { selectTaskCustomFields } from "../../customFields/selectors"
import {getCustomFieldsFilters, getNextTaskStatusFilter, getSelectedFilterKeys} from "../common/selectors"
import { setTaskListFilters } from "../common/actions";
import {getNextWorkflowStatusesArray} from '../../entities/selectors'

class FiltersPanel extends TemplateView {
    constructor({
        setTaskListFilters,
    }) {
        super()

        this.state = {
            customFields: [],
            workflowStatuses: [],
            selectedFilterKeys: [],
            customFieldsFilters: {},
            taskStatusFilter: {
                allSelected: false,
                statusIds: [],
                statusTypes: [],
            },
        }

        this.actions = {
            setTaskListFilters
        }

        this.onAnyStatePropertyChanged(['taskStatusFilter', 'customFieldsFilters'], ({ taskStatusFilter, customFieldsFilters }) => {
            this.panel.setProps({
                filters: {
                    status: taskStatusFilter,
                    customFields: customFieldsFilters
                }
            })
        })

        this.onStatePropertyChanged('customFields', (customFields) => {
            this.panel.setProps({
                customFields: customFields
            })
        })

        this.onStatePropertyChanged('workflowStatuses', (workflowStatuses) => {
            this.panel.setProps({
                workflowStatuses: workflowStatuses
            })
        })

        this.onStatePropertyChanged('selectedFilterKeys', (selectedFilterKeys) => {
            this.panel.setProps({
                visibleFilterKeys: new Set(selectedFilterKeys)
            })
        })
    }

    templateHtml() {
        return "<div class='atNextMount'></div>"
    }

    afterRender() {
        this.panel = ClassicBridge.integrateTaskListFiltersPanel(this.$el[0], {
            customFields: this.state.customFields,
            filters: {
                status: this.state.taskStatusFilter,
                customFields: this.state.customFieldsFilters
            },
            onChangeSearch: (text) => $(document).trigger("taskManagement_tasksTable_tasksSearchField_change", [text]),
            onChangeFilters: (filters) => {
                filters.status.statusIds = filters.status.statusIds.map((workflowStatusId) => {
                    const workflowStatus = this.state.workflowStatuses.find((status) => workflowStatusId === status.id)
                    return workflowStatus ? workflowStatus.classicId : workflowStatusId
                })

                this.actions.setTaskListFilters(filters)
            },
            visibleFilterKeys: new Set(this.state.selectedFilterKeys),
            workflowStatuses: this.state.workflowStatuses
        })

        this.renderInitialState()
    }
}

export default connect(
    (state) => ({
        customFields: selectTaskCustomFields(state),
        workflowStatuses: getNextWorkflowStatusesArray(state),
        customFieldsFilters: getCustomFieldsFilters(state),
        selectedFilterKeys: getSelectedFilterKeys(state),
        taskStatusFilter: getNextTaskStatusFilter(state),
    }),
    (dispatch) => ({
        setTaskListFilters: bindActionCreators(setTaskListFilters, dispatch),
    })
)(FiltersPanel)



// WEBPACK FOOTER //
// ./web/js/taskManagement/header/FiltersPanel.js